import script from "./PartnersOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartnersOverview.vue?vue&type=script&setup=true&lang=ts"

import "./PartnersOverview.vue?vue&type=style&index=0&id=3eb5ceb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb5ceb2"]])

export default __exports__